import React, { memo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { EntityCrudActions, EntityDetailActions } from 'actions';

import { RouteOnMount } from 'utils/routes';
import { CAMPAIGNS } from 'constants/Entities';
import DetailLayout from 'containers/components/layouts/ContentDetailLayout';
import Menu from './Menu';
import Content from './Content';
import ContentNavigator from './ContentNavigator';
import Crud from './Crud';
import Detail from './components/Detail';

const ActivityCampaigns = memo(() => {
    const dispatch = useDispatch();
    const canCreate = useSelector((state) => state?.config?.permission?.createCampaigns ?? false);

    const openCrud = bindActionCreators(EntityCrudActions, dispatch).init;
    const openDetail = bindActionCreators(EntityDetailActions, dispatch).open;
    const currentDetailId = useRef();

    return (
        <>
            <DetailLayout header={<Menu />} navigator={<ContentNavigator />}>
                <Content />
            </DetailLayout>
            <Crud />
            <Detail />
            <Routes>
                <Route
                    path="/"
                    element={
                        <RouteOnMount
                            title="page_title_campaigns"
                            onMount={() => {
                                currentDetailId.current = null;
                            }}
                        />
                    }
                />
                <Route
                    path="/new"
                    element={
                        <RouteOnMount
                            title="page_title_campaigns_create"
                            onMount={() => {
                                if (!canCreate) return;
                                currentDetailId.current = null;
                                openCrud({ entity: CAMPAIGNS });
                            }}
                        />
                    }
                />
                <Route
                    path="/:id/edit"
                    element={
                        <RouteOnMount
                            title="page_title_campaigns_edit"
                            onMount={(params) => {
                                if (!params.id) return;
                                currentDetailId.current = null;
                                openCrud({ entity: CAMPAIGNS, id: Number(params.id) });
                            }}
                        />
                    }
                />
                <Route
                    path="/:id/:tab?"
                    element={
                        <RouteOnMount
                            title="page_title_campaigns_details"
                            onMount={(params) => {
                                if (!params.id) return;
                                // If we were here then we don't need to open campaigns detail again
                                if (
                                    currentDetailId.current &&
                                    currentDetailId.current === params.id
                                )
                                    return;
                                currentDetailId.current = params.id;
                                openDetail(CAMPAIGNS, Number(params.id), false, {
                                    tab: params.tab,
                                });
                            }}
                        />
                    }
                />
            </Routes>
        </>
    );
});

export default ActivityCampaigns;
